import { Amplify } from "aws-amplify";
import { parseAmplifyConfig } from "aws-amplify/utils";
import awsOutputs from "../amplify_outputs.json";
import { getBackendEnv } from "../store/utils/consts";

// Gen2 (amplify_outputs.json) configuration — mirrors the playground / platform
// migration. panel-ui talks to GraphQL (lambda authorizer) and Storage only and
// makes no REST/custom.API calls, so parseAmplifyConfig (auth + data + storage)
// is all that's needed — no manual API.REST wiring.
export function configureAmplify() {
  const parsedConfig = parseAmplifyConfig(awsOutputs);

  // Point GraphQL at the custom domain on the deployed envs (dev.* on dev, bare
  // host on master/staging). Local (sandbox) keeps the raw AppSync endpoint from
  // the outputs — the custom domain only fronts the deployed backends. Guard the
  // override so a partial outputs file fails loudly here instead of silently
  // leaving Amplify unconfigured (which surfaces as "Auth UserPool not
  // configured").
  const env = getBackendEnv();
  // Escape hatch for testing a freshly deployed backend before its custom domain
  // has been repointed at it. Build with REACT_APP_RAW_GRAPHQL=true to keep the
  // raw AppSync endpoint from amplify_outputs.json. Needed because a custom
  // domain can still front the previous (Gen1) API, in which case the rewrite
  // would silently send traffic to the old backend and the test would pass for
  // the wrong reason.
  const useRawEndpoint = process.env.REACT_APP_RAW_GRAPHQL === "true";
  if (env !== "local" && !useRawEndpoint) {
    const prefix = env === "dev" ? "dev." : "";
    if (parsedConfig.API?.GraphQL) {
      parsedConfig.API.GraphQL.endpoint = `https://${prefix}graphql.blings.io/graphql`;
    } else {
      console.error(
        "[initAmplify] amplify_outputs.json has no GraphQL/data resource — " +
          "GraphQL endpoint not overridden. Check `ampx generate outputs` for this branch."
      );
    }
  }

  // Log the endpoint actually in use so a build can be confirmed against the
  // backend it is meant to be talking to.
  console.log(
    `[initAmplify] env=${env} graphql=${
      parsedConfig.API?.GraphQL?.endpoint ?? "(unset)"
    }` +
      (useRawEndpoint ? " (raw endpoint, custom-domain rewrite skipped)" : "")
  );

  Amplify.configure(parsedConfig);

  if (!parsedConfig.Auth?.Cognito?.userPoolId) {
    console.error(
      "[initAmplify] amplify_outputs.json has no auth.Cognito.userPoolId — " +
        "sign-in will fail with 'Auth UserPool not configured'. " +
        "Check `ampx generate outputs` for this branch and the backend auth resource."
    );
  }
}

// Side-effect: configure Amplify on import. index.tsx imports this module first,
// before App or anything that touches Amplify/Auth, so configuration always runs.
configureAmplify();
